import { useEffect, useState } from 'react';
import { useWhitelabel } from './useWhitelabel';

export const useApplicationTitle = () => {
  const { whitelabelTexts, isLoadingTexts } = useWhitelabel();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (isLoadingTexts) {
      return;
    }

    const setTitle = (title: string) => {
      if (title) {
        document.title = title;
      }
    };

    if (whitelabelTexts?.title) {
      setTitle(whitelabelTexts.title);
    }
    setIsLoading(false);
  }, [whitelabelTexts?.title, isLoadingTexts]);

  return { isLoading };
};
